(function() {
    var header = '.header-wrapper .header';
    var announcementBar = '#shopify-section-announcement-bar';
    var mobileWrapper = '.main-navigation-wrapper.navigation-mobile';
    var mobileMainNav = '.main-navigation-wrapper.navigation-mobile .main-navigation';
    var mobileNavToggle = '.navigation-toggle > button';
    var menuHasDropdown = '.navigation-list-item.has-dropdown.has-super-nav';
    var mobileSearchActive = '.header-search-submit.header-search-submit--minimal.search-submit-active';
    var mobileSearchWrapper = '.header-search.mobile';
    var mobileSearchButton = '.header-search.mobile .header-search-submit';
    var headerLogo = '.header-wrapper .header .header-logo';
    var desktopSearchButton = '.header-tools .header-search-form-wrapper .header-search-submit';
    var indexFeaturedCollection = '.section-index-products';
    var productGallery = '#product-media .product-media-inner';

    dockedHeader(header, announcementBar);
    mobileHeaderBackgroundFix(header, mobileNavToggle, mobileSearchActive);
    removeMobileNav(mobileSearchWrapper);
    searchToggleHideLogo(mobileSearchButton, desktopSearchButton, headerLogo, header);
    //mobileNavTop(header, mobileMainNav);
    swiperArrowsTop(indexFeaturedCollection);
    accordion();
})();

function dockedHeader(header, announcementBar) {
    $(window).on('scroll', function () {
        var windowScrollTop = $(window).scrollTop();      

        if (windowScrollTop > $(header).outerHeight() + $(announcementBar).outerHeight() + 20) {
          $(header).addClass('docked-header');
        } else if(windowScrollTop < $(header).outerHeight()) {
          $(header).removeClass('docked-header');
        }
    });
}

function mobileNavTop(header, mobileMainNav) {
    if ($('body').hasClass('template-index')) {
        $(mobileMainNav).css('top', $(header).outerHeight() + 'px');
    }
}

function mobileHeaderBackgroundFix(header, mobileNavToggle, mobileSearchActive) {
    $(document).on('click', mobileNavToggle, function(e) {
        if ($(mobileSearchActive).length == 0) {
            $(header).toggleClass('header-background-white');
        }
    })
}

function removeMobileNav(mobileSearchWrapper) {
    if ($(window).width() > 768) {
        $(mobileSearchWrapper).remove();
    }
}

function searchToggleHideLogo(mobileSearchButton, desktopSearchButton, headerLogo, header) {
    if ($(window).width() <= 768) {
        $(document).on('click', mobileSearchButton, function(e) {
            if ($('header').hasClass('mobile-navigation-open')) {
                $(headerLogo).toggleClass('visually-hidden');
            } else {
                $(headerLogo).toggleClass('visually-hidden');
                $(header).toggleClass('header-background-white');
            }
        })
    } else {
        $(document).on('click', desktopSearchButton, function(e) {
            $(header).toggleClass('header-background-white');
        })
    }
}

function swiperArrowsTop(indexFeaturedCollection) {
    $(indexFeaturedCollection + ' .swiper-button-prev').css('top', 'unset');
    $(indexFeaturedCollection + ' .swiper-button-next').css('top', 'unset');
}

// Accordion Tabs
function accordion() {
    $('.tab-header').click(function(e) {
        $(this).closest('.tab').find('.tab-content').slideToggle(300);
        $(this).closest('.tab').toggleClass('active');
        $(this).closest('.tab').siblings().find('.tab-content').slideUp(300);
        $(this).closest('.tab').siblings().removeClass('active');
        $(this).find('.tab-icon--expand').attr('aria-expanded', function (i, attr) {
          return attr == 'true' ? 'false' : 'true';
        });
    });
}
